module.exports = new __parcel__URL__("empty-cannot-view-item.d6ba9b64.svg").toString();